export enum SubscriptionLevel {
  OPTIMAL = 1,
  STOR = 2,
  GRUNDLAGGANDE = 3,
  MINIMAL = 4,
  STARTUP = 5,
  CUSTOM = 6,
}

export const packageDefaults: Record<
  SubscriptionLevel,
  { users: number; workplaces: number }
> = {
  [SubscriptionLevel.OPTIMAL]: { users: 16, workplaces: 4 },
  [SubscriptionLevel.STOR]: { users: 5, workplaces: 2 },
  [SubscriptionLevel.GRUNDLAGGANDE]: { users: 2, workplaces: 1 },
  [SubscriptionLevel.MINIMAL]: { users: 1, workplaces: 1 },
  [SubscriptionLevel.STARTUP]: { users: 1, workplaces: 1 },
  [SubscriptionLevel.CUSTOM]: { users: 1, workplaces: 1 },
};
